export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/viewer/icon-sound-off-light-bfdd4046da12d5b29c98f3e06f8f062e.svg";